<template>
    <section class="mt-16">
        <v-breadcrumbs
          large
          :items="crumbs"
          divider="/"
          class="pl-0"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-currency-eur</v-icon> <span>Criar despesa</span>
        </h1>
  
        <div class="mt-16">
          <Despesa method="create"></Despesa>
        </div>
    </section>
  </template>
  <script>
  import Despesa from '@/components/Despesas/Despesas.vue'
  
  export default {
    components: {
        Despesa
    },
    beforeCreate(){
      document.title = "ODC - Criar despesa";
    },
    data: () => ({
      
    }),
    mounted(){
      if(!this.$store.getters.hasPermission(['super', 'expenses.write']))
      {
        this.$router.push('/');
      }  
    },
    methods:{
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: 'Dashboard',
            disabled: false,
            to: '/admin',
            exact: true,
          },
          {
            text: 'Criar despesa',
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  